import { render, staticRenderFns } from "./transfer-order-receipt.vue?vue&type=template&id=0cf68be6&scoped=true&"
import script from "./transfer-order-receipt.vue?vue&type=script&lang=ts&"
export * from "./transfer-order-receipt.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-order-receipt.vue?vue&type=style&index=0&id=0cf68be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf68be6",
  null
  
)

export default component.exports